export const AppConfig = {
  base: window.APP_CONFIG.BASE,
  serverUrl: import.meta.env.VITE_API_URL || window.APP_CONFIG.SERVER_URL,
  arViewerUrl: window.APP_CONFIG.AR_VIEWER_URL,
};
